import { uuidv4 } from "@/util/helpers";
import { defineStore } from "pinia";

export const useDialogStore = defineStore("dialog", {
  state: () => ({
    show: false,
    dialogStack: []
  }),
  actions: {
    // returnDialogHandle can be used when you want manual control over manually closing a specific dialog
    showDialog({ component, returnHandle = false, ...props }) {
      this.show = true;
      const key = uuidv4();

      let dialogData;

      const promise = new Promise(resolve => {
        dialogData = {
          resolve,
          component,
          key,
          close: () => this.closeSpecificDialog(key),
          props: { ...props, isDialog: true }
        };
      });

      dialogData.promise = promise;

      this.dialogStack.push(dialogData);

      if (returnHandle) {
        return dialogData;
      }

      return promise;
    },
    closeAll(res = {}) {
      const count = this.dialogStack.length;
      for (let i = 0; i < count; i++) {
        this.closeDialog(res);
      }
    },
    closeSpecificDialog(key) {
      const specificDialogIndex = this.dialogStack.findIndex(
        ds => ds.key === key
      );

      if (specificDialogIndex === -1) return;

      if (this.dialogStack.length <= 1) {
        this.show = false;
      }
      if (!this.dialogStack.length) return;

      let dialog;
      if (specificDialogIndex === this.dialogStack.length - 1) {
        dialog = this.dialogStack.pop();
      } else {
        dialog = this.dialogStack[specificDialogIndex];
        this.dialogStack.splice(specificDialogIndex, 1);
      }

      dialog.resolve();
    },
    closeDialog(props) {
      if (this.dialogStack.length <= 1) {
        this.show = false;
      }
      if (!this.dialogStack.length) return;

      const last = this.dialogStack.pop();

      last.resolve(props || {});
    }
  }
});
